import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card_container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "main_text" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'noData',
  props: {
    image: {},
    text: {}
  },
  setup(__props: any) {

const { t } = useI18n();
const props = __props

const noDataImage = computed(() => {
    return props.image || require('@/assets/themeFour/n1.png')
})
const noDataText = computed(() => {
    return props.text || t('common.noRecords')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: noDataImage.value,
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString(noDataText.value), 1)
  ]))
}
}

})